import React, { useState } from "react";

export default function StepContact({ data, onUpdate, onBack, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    if (!data.email || !data.phone) {
      setError("Please enter both email and phone number");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const eligibilityResponse = await fetch("https://your-api-url.com/eligibility", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      if (!eligibilityResponse.ok) {
        throw new Error("Eligibility submission failed");
      }

      setSubmitted(true);
      if (typeof onSuccess === "function") {
        onSuccess();
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
        <h2 className="text-2xl font-semibold text-primary">
          Check your inbox 📬
        </h2>
        <p className="text-primary-dark mt-3 text-sm">
          We’ve sent your eligibility results to <br />
          <strong>{data.email}</strong>
        </p>
        <p className="text-xs text-primary-dark mt-4">
          Our counselor may contact you shortly.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl p-8 shadow-lg">
      <h2 className="text-xl font-semibold text-primary mb-4">
        Get your eligibility result
      </h2>

      <p className="text-sm text-primary-dark mb-6">
        Enter your details and receive your eligibility report by email.
      </p>

      <div className="space-y-4">
        <input
          type="email"
          placeholder="Email address"
          value={data.email}
          onChange={(e) => onUpdate({ email: e.target.value })}
          className="w-full px-4 py-3 border rounded-lg"
        />

        <input
          type="tel"
          placeholder="Phone number"
          value={data.phone}
          onChange={(e) => onUpdate({ phone: e.target.value })}
          className="w-full px-4 py-3 border rounded-lg"
        />
      </div>

      {error && <p className="text-red-500 text-xs mt-3">{error}</p>}

      <div className="flex justify-between items-center mt-6">
        <button
          onClick={onBack}
          className="text-sm text-primary-dark underline"
        >
          Back
        </button>

        <button
          onClick={handleSubmit}
          disabled={loading}
          className="px-6 py-3 bg-primary text-white rounded-lg text-sm font-medium"
        >
          {loading ? "Submitting..." : "Get My Eligibility Result"}
        </button>
      </div>
    </div>
  );
}
